(function () {

  function dispatchNativeEvents(el) {
    try {
      el.dispatchEvent(new Event('input', { bubbles: true }));
      el.dispatchEvent(new Event('change', { bubbles: true }));
    } catch (e) {
      var evt1 = document.createEvent('Event');
      evt1.initEvent('input', true, true);
      el.dispatchEvent(evt1);
      var evt2 = document.createEvent('Event');
      evt2.initEvent('change', true, true);
      el.dispatchEvent(evt2);
    }
  }

  function setHidden(name, value) {
    var elements = document.querySelectorAll('[name="' + name + '"]');
    if (!elements.length) return;

    var finalValue = (value !== null && value !== undefined) ? String(value) : '';
    elements.forEach(function (el) {
      el.value = finalValue;
      el.setAttribute('value', finalValue);
      dispatchNativeEvents(el);
    });

    // Segunda pasada para que JetFormBuilder recalcule campos calculados
    setTimeout(function () {
      elements.forEach(function (el) {
        try {
          el.dispatchEvent(new Event('input', { bubbles: true }));
          el.dispatchEvent(new Event('change', { bubbles: true }));
        } catch (e) { /* ignorado */ }
      });
    }, 50);
  }

  function clearMotoHiddenFields() {
    ['hidden_impvehic', 'hidden_cilindrada', 'hidden_potencia_fiscal'].forEach(function (name) {
      setHidden(name, '');
    });
  }

  function fetchJSON(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    });
  }

  function formatLabel(tramo, idx) {
    var desde = parseFloat(String(tramo.cilindrada_desde || '0').replace(',', '.'));
    var hasta  = parseFloat(String(tramo.cilindrada_hasta  || '').replace(',', '.'));

    if (idx === 0 || desde === 0) {
      return 'Hasta ' + hasta + ' c.c.';
    }
    if (isNaN(hasta) || tramo.cilindrada_hasta === '' || tramo.cilindrada_hasta === null) {
      return 'Más de ' + desde + ' c.c.';
    }
    return 'Más de ' + desde + ' c.c. y menor o igual que ' + hasta + ' c.c.';
  }

  function setOptions(select, tramos) {
    select.innerHTML = '';

    var ph = document.createElement('option');
    ph.value = '';
    ph.textContent = '-- Seleccione cilindrada --';
    select.appendChild(ph);

    tramos.forEach(function (tramo, idx) {
      var opt = document.createElement('option');
      opt.value = tramo.seqmotoc;
      opt.dataset.importe    = tramo.importe_valor   || '';
      opt.dataset.cilindrada = tramo.cilindrada_hasta || tramo.cilindrada_desde || '';
      opt.textContent = formatLabel(tramo, idx);
      select.appendChild(opt);
    });

    dispatchNativeEvents(select);
  }

  function loadTramos(select) {
    fetchJSON('/wp-json/catalogos/v1/motos/tramos?tipo=MO')
      .then(function (data) {
        setOptions(select, data.options || []);
        clearMotoHiddenFields();
      })
      .catch(function (err) {
        console.error('Error cargando tramos de motos:', err);
      });
  }

  function onCilindradaChange(select) {
    var opt = select.options[select.selectedIndex];

    if (!opt || !opt.value) {
      clearMotoHiddenFields();
      return;
    }

    setHidden('hidden_impvehic',  opt.dataset.importe    || '');
    setHidden('hidden_cilindrada', opt.dataset.cilindrada || '');
    // hidden_potencia_fiscal no aplica para motos por cilindrada

    window.dispatchEvent(new CustomEvent('itp:vehiculo-updated'));
  }

  // ── Inicialización del select ───────────────────────────────────────────────
  var motoSelect = null;

  function onSelectChange() {
    onCilindradaChange(motoSelect);
  }

  function initSelect(select) {
    if (select === motoSelect) {
      // Mismo elemento: solo recargar tramos (el listener ya está puesto)
      loadTramos(select);
      return;
    }

    // Elemento nuevo (re-renderizado por JFB): poner listener y cargar tramos
    if (motoSelect) {
      motoSelect.removeEventListener('change', onSelectChange);
    }
    motoSelect = select;
    motoSelect.addEventListener('change', onSelectChange);
    loadTramos(motoSelect);
  }

  function tryInitSelect() {
    var el = document.querySelector('select[name="cilindrada_moto"]');
    if (!el) return false;
    initSelect(el);
    return true;
  }

  if (!tryInitSelect()) {
    var observer = new MutationObserver(function () {
      if (tryInitSelect()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // ── Re-inicializar al seleccionar veh_moto ─────────────────────────────────
  // Necesario porque JFB puede eliminar y volver a crear el select al mostrar
  // el bloque condicional, perdiendo así el listener y las opciones cargadas.
  document.addEventListener('DOMContentLoaded', function () {

    function onVehiculoChange() {
      var checked = document.querySelector('[name="elegir_vehiculo"]:checked');
      if (!checked || checked.value !== 'veh_moto') return;

      // Dar tiempo a JFB para que renderice el bloque condicional
      setTimeout(function () {
        var el = document.querySelector('select[name="cilindrada_moto"]');
        if (el) initSelect(el);
      }, 100);
    }

    function attachVehiculoListeners() {
      var radios = document.querySelectorAll('[name="elegir_vehiculo"]');
      if (!radios.length) return false;
      radios.forEach(function (r) {
        r.addEventListener('change', onVehiculoChange);
      });
      return true;
    }

    if (!attachVehiculoListeners()) {
      var obs = new MutationObserver(function () {
        if (attachVehiculoListeners()) obs.disconnect();
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }

  });

})();



// WEBPACK FOOTER //
// ./scripts/formularios-itp/catalogos-motos.js